/*jshint esversion: 6 */

import { combineReducers } from 'redux';
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase';
import userReducer from './user-reducer';
import quizReducer from './quiz-reducer';
import accountModalReducer from './account-modal-reducer';

// Combine Reducers
var reducers = combineReducers({
    firebase: firebaseReducer,
    //userState: userReducer,
    quiz: quizReducer,
    accountModalReducer: accountModalReducer,
});

export default reducers;

